import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/CustomerIndustry`;

export const GetCustomerIndustryList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/GetCustomerIndustryList`,
    params
  );
  return res;
};

export const AddUpdateCustomerIndustry = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/AddUpdateCustomerIndustry?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetCustomerIndustryModel = async (
  ModuleName,
  KeyID,
  AdminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetCustomerIndustryModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&CustomerIndustryKeyID=${KeyID}`
  );
  return res;
};

export const ChangeCustomerIndustryStatus = async (
  ModuleName,
  KeyID,
  AdminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/ChangeCustomerIndustryStatus?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&CustomerIndustryKeyID=${KeyID}`
  );
  return res;
};

export const DeleteCustomerIndustry = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/DeleteCustomerIndustry?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&CustomerIndustryKeyID=${KeyID}`
  );
  return res;
};

export const GetCustomerIndustryLookupList = async (AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetCustomerIndustryLookupList?AdminKeyID=${AdminKeyID}`
  );
  return res;
};
